import Accordion from './Accordion.svelte';
export * from './Accordion.types.js';
import PanelComponent from './Panel.svelte';
export * from './Panel.types.js';
const Panel = PanelComponent;
import HeaderComponent from './Header.svelte';
export * from './Header.types.js';
const Header = HeaderComponent;
import { Content } from '@smui/paper';
export default Accordion;
export { Panel, Header, Content };
//# sourceMappingURL=index.js.map